import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, filter, map } from 'rxjs/operators';
import { RECEIVE_TIME_SC } from 'src/app/common/const';
import { TIMETABLE_MSECS } from 'src/app/reports/model/stop-pile-stats';
import { ValueField } from 'src/app/settings/model/value-field';
import { FieldsService } from 'src/app/settings/service/fields.service';
import { DeviceType } from 'src/app/vehicles/model/device-type';
import { SP_CODE, SP_NAME } from 'src/app/vehicles/model/stop-pile';
import { ChartJson, PeopleCountersChartDataPreparatorService } from '../../../reports/service/people-counters-chart-data-preparator.service';
import { ChartType } from '../../model/chart-type';
import { ErrorType } from '../../model/error-type';
import { PlotlyBarInput } from '../../model/plotly-bar-input';
import { PlotlyPieInput } from '../../model/plotly-pie-input';
import { RequestCriteria } from '../../model/request-criteria';
import { ViewState } from '../../model/view-state';
import { FieldsData, LabelFieldsSelectorDialogComponent } from '../dialog/label-fields-selector-dialog/label-fields-selector-dialog.component';

@Component({
  selector: 'app-chart-view',
  templateUrl: './chart-view.component.html',
  styleUrls: ['./chart-view.component.scss']
})
export class ChartViewComponent implements OnInit {

  @Input()
  fileId: number;

  @Input()
  chartType: ChartType;

  @Input()
  filters: RequestCriteria;

  @Input()
  viewState: ViewState;

  graph: Observable<PlotlyBarInput | PlotlyPieInput>;
  errorType: ErrorType = null;
  errorTypeHelper: typeof ErrorType = ErrorType; // to pass type to template

  constructor(private chartPreparatorService: PeopleCountersChartDataPreparatorService, private fieldsService: FieldsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.initChartData();
  }

  private initChartData(chartJson: ChartJson = null, fieldsForLabels: ValueField[] = null): void {
    this.graph = this.chartPreparatorService.getChartDataAsPlotlyInput(chartJson, this.fileId, this.chartType, this.filters, this.viewState,
      fieldsForLabels, (chartData) => this.showSelectLabelFieldsDialog(chartData))
      .pipe(
        catchError((error) => {
          if (error?.message == ErrorType.NO_DATA_TO_SHOW) {
            this.errorType = ErrorType.NO_DATA_TO_SHOW;
          } else {
            console.error(error);
            this.errorType = ErrorType.SERVER_CONNECTION_ERROR;
          }
          return of<PlotlyBarInput | PlotlyPieInput>();
        })
      );
  }

  private showSelectLabelFieldsDialog(chartJson: ChartJson): void {
    this.fieldsService.getFieldsForType(DeviceType.BUS_STOP_REPORT)
      .pipe(
        map(fields => fields.filter(field => field.visible)),
        switchMap(fields => {
          const defaultFields = [RECEIVE_TIME_SC, SP_CODE, SP_NAME];
          const data: FieldsData = {
            fields,
            requireAny: fields.filter(field => field.name == RECEIVE_TIME_SC || field.name == TIMETABLE_MSECS),
            defaultValues: fields.filter(field => defaultFields.includes(field.name))
          };
          return this.dialog.open(LabelFieldsSelectorDialogComponent, { data, width: '450px' }).afterClosed();
        }),
        filter(result => result != null)
      )
      .subscribe((fieldsForLabels: ValueField[]) => this.initChartData(chartJson, fieldsForLabels));
  }
}
